import {
  getUserList,
  pathUserAdministration,
  getDashboarData1,
  getDashboarData2,
  getDashboarDataTask,
  getDashboarDataReward,
  getDashboarDataProduct,
  getDashboarDataBestSale,
  getDashboarDataPerMonth,
  receiptReport,
  additionalPointReport,
  educationReport,
  receiptManagerReport,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { toast } from "react-toastify";
import { userActions } from "../reducers/user";
import { t } from "i18next";
import { exportToExcel } from "../utils/exportToExcel";

export const fetchUserList = (id_user = 0) => {
  return (dispatch) => {
    return apiService
      .get(getUserList(id_user))
      .then((response) => {
        id_user == 0
          ? dispatch(userActions.fetchUserList(response.data))
          : dispatch(userActions.fetchUserDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboarData = () => {
  return (dispatch) => {
    return apiService
      .get(getDashboarData1())
      .then((response) => {
        dispatch(userActions.fetchDashboarData(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboarDataMore = () => {
  return (dispatch) => {
    return apiService
      .get(getDashboarData2())
      .then((response) => {
        dispatch(userActions.fetchDashboarDataMore(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardDataTask = () => {
  return (dispatch) => {
    return apiService
      .get(getDashboarDataTask())
      .then((response) => {
        dispatch(userActions.fetchDashboarDataTask(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardDataReward = () => {
  return (dispatch) => {
    return apiService
      .get(getDashboarDataReward())
      .then((response) => {
        dispatch(userActions.fetchDashboarDataReward(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardDataProduct = () => {
  return (dispatch) => {
    return apiService
      .get(getDashboarDataProduct())
      .then((response) => {
        dispatch(userActions.fetchDashboarDataProduct(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardDataBestSale = () => {
  return (dispatch) => {
    return apiService
      .get(getDashboarDataBestSale())
      .then((response) => {
        dispatch(userActions.fetchDashboarDataBestSale(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardDataPerMonth = () => {
  return (dispatch) => {
    return apiService
      .get(getDashboarDataPerMonth())
      .then((response) => {
        dispatch(userActions.fetchDashboarDataPerMonth(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewUser = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathUserAdministration(), data)
      .then((response) => {
        // dispatch(userActions.fetchUserList(response.data));
        navigate("/user-list");
        toast.success(t("administratorsListActions.created"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const updateUser = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathUserAdministration(), data)
      .then((response) => {
        // dispatch(userActions.fetchUserList(response.data));
        navigate("/user-list");
        toast.success(t("administratorsListActions.updated"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};

export const createReceiptReport = (data) => {
  return (dispatch) => {
    const receiptReportHeaders = {
      countryName: "Država",
      companyName: "Kompanija",
      storeName: "Prodavnica",
      receiptNumber: "Broj računa",
      receiptCopyNumber: "Broj kopije računa",
      dateOnReceipt: "Datum na računu",
      dateOnReceiptCopy: "Datum na kopiji računa",
      createdAt: "Datum kreiranja",
      approvalDate: "Datum odobrenja",
      category1: "Kategorija 1",
      category2: "Kategorija 2",
      category3: "Kategorija 3",
      productName: "Naziv proizvoda",
      productPoints: "Poeni proizvoda",
      quantity: "Količina",
      name: "Ime",
      lastName: "Prezime",
      sector: "Sektor",
      points: "Ukupno poena",
    };

    return apiService
      .get(receiptReport(data))
      .then((response) => {
        const reportData = response.data;

        const translatedData = reportData.map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              receiptReportHeaders[key] || key,
              value,
            ])
          )
        );

        if (!Array.isArray(reportData) || reportData.length === 0) {
          toast.error("Nema dostupnih podataka", { theme: "colored" });
          return;
        }

        exportToExcel(
          translatedData,
          "Izveštaj o računima " + data?.dateFrom + " - " + data?.dateTo
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createManagerReport = (data) => {
  return (dispatch) => {
    const managerReportHeaders = {
      countryName: "Država",
      companyName: "Kompanija",
      storeName: "Prodavnica",
      receiptNumber: "Broj računa",
      receiptCopyNumber: "Broj kopije računa",
      dateOnReceipt: "Datum na računu",
      dateOnReceiptCopy: "Datum na kopiji računa",
      createdAt: "Datum kreiranja",
      approvalDate: "Datum odobrenja",
      name: "Ime menadžera",
      lastName: "Prezime menadžera",
      points: "Ukupno poena",
      employeeName: "Ime zaposlenog",
      employeeLastName: "Prezime zaposlenog",
    };

    return apiService
      .get(receiptManagerReport(data))
      .then((response) => {
        const reportData = response.data;

        if (!Array.isArray(reportData) || reportData.length === 0) {
          toast.error("Nema dostupnih podataka", { theme: "colored" });
          return;
        }

        // ✨ PREVOD
        const translatedData = reportData.map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              managerReportHeaders[key] || key,
              value,
            ])
          )
        );

        exportToExcel(
          translatedData,
          "Izveštaj za menadžere " + data?.dateFrom + " - " + data?.dateTo
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createEducatorReport = (data) => {
  return (dispatch) => {
    const educatorReportHeaders = {
      countryName: "Država",
      companyName: "Kompanija",
      storeName: "Prodavnica",
      name: "Ime",
      lastName: "Prezime",
      educationName: "Naziv obuke",
      points: "Poeni",
    };

    return apiService
      .get(educationReport(data))
      .then((response) => {
        const reportData = response.data;

        if (!Array.isArray(reportData) || reportData.length === 0) {
          toast.error("Nema dostupnih podataka", { theme: "colored" });
          return;
        }

        // Prevod polja
        const translatedData = reportData.map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              educatorReportHeaders[key] || key,
              value,
            ])
          )
        );

        exportToExcel(
          translatedData,
          "Izveštaj za edukatore " + data?.dateFrom + " - " + data?.dateTo
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createAdditionalPointReport = (data) => {
  return (dispatch) => {
    const additionalPointReportHeaders = {
      countryName: "Država",
      companyName: "Kompanija",
      storeName: "Prodavnica",
      name: "Ime",
      lastName: "Prezime",
      points: "Poeni",
      createdAt: "Datum kreiranja",
    };

    return apiService
      .get(additionalPointReport(data))
      .then((response) => {
        const reportData = response.data;

        if (!Array.isArray(reportData) || reportData.length === 0) {
          toast.error("Nema dostupnih podataka", { theme: "colored" });
          return;
        }

        const translatedData = reportData.map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              additionalPointReportHeaders[key] || key,
              value,
            ])
          )
        );

        exportToExcel(
          translatedData,
          "Izveštaj o dodatnim poenima " + data?.dateFrom + " - " + data?.dateTo
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
